import React, { useState, useEffect, useContext } from "react";
import ButtonNext from "../../../components/button/ButtonWhite";
import ButtonTransparent from "../../button/ButtonTransparent";
import Benefactor from "../../layouts/Benefactores";
import ButtonBack from "../../button/ButtonBack";
import CopyNotification from "../../banners/CopyNotification";
import { UtilContext } from "../../../context/UtilContext";

import { ReactComponent as NEXT } from "../../../assets/IconsColurs/IconsGeneral/chevronRight.svg";
import { ReactComponent as ADD } from "../../../assets/IconsColurs/IconsGeneral/add.svg";
import ButtonWhite from "../../../components/button/ButtonWhite";
import { ReactComponent as BACK } from "../../../assets/IconsColurs/IconsGeneral/chevronLeft.svg";
import { GLOBAL_LANGUAGE } from "../../../language/language";

const Step4 = ({
  buttonOff,
  onClick,
  isDisabled,
  onClickBack,
  copyToClipboard,
  errorMesagge = "",
  save,
  ListCountry,
  DataCompany,
  shareholders,
  LoadingLayouts,
  copied,
  setShareholders,
  loading,
  ErrorCompany,
  LoadingBenefactores,
  LoadingBack,
}) => {
  const [isReady, setIsReady] = useState(false);

  const [beneficiarios, setBeneficiarios] = useState([]);
  const [nuevosBeneficiarios, setNuevosBeneficiarios] = useState([]);

  const { language } = useContext(UtilContext); // Usa el contexto de Auth

  useEffect(() => {
    if (DataCompany && Array.isArray(DataCompany) && DataCompany.length > 0) {
      setBeneficiarios([...DataCompany]);
    }


    if (DataCompany == null) {
      addBeneficiario()
    }
  }, [DataCompany]);

  const addBeneficiario = () => {
    const nuevoBeneficiario = {
      type_person: 1,
      first_name: "",
      last_name: "",
      participation_percentage: "",
      country: "",
      enterprise_legal_name: "",
      enterprise_identification: "",
      is_pep: false,
      documents_step_4: []
    };

    setBeneficiarios((prev) => [...prev, nuevoBeneficiario]);
    setNuevosBeneficiarios((prev) => [...prev, nuevoBeneficiario]);
  };

  const handleBeneficiarioChange = (index, field, value) => {
    const updatedBeneficiarios = [...beneficiarios];
    updatedBeneficiarios[index][field] = value;

    setBeneficiarios(updatedBeneficiarios);

    // Actualizamos también los beneficiarios nuevos si el índice pertenece a un nuevo
    if (nuevosBeneficiarios.includes(beneficiarios[index])) {
      const updatedNuevosBeneficiarios = [...nuevosBeneficiarios];
      updatedNuevosBeneficiarios[
        nuevosBeneficiarios.indexOf(beneficiarios[index])
      ][field] = value;
      setShareholders(updatedNuevosBeneficiarios)
      setNuevosBeneficiarios(updatedNuevosBeneficiarios);
    }
  };

  const isReadyToRender =
    !LoadingBenefactores &&
    beneficiarios?.length > 0 &&
    ListCountry?.length > 0;
  console.log("asasasas", !LoadingBenefactores && beneficiarios != null &&
    beneficiarios?.length > 0 &&
    ListCountry?.length > 0);

  const handleSave = () => {
    save(nuevosBeneficiarios); // Solo enviamos los nuevos beneficiarios
  };
  useEffect(() => {
    if (
      !LoadingLayouts

    ) {
      setIsReady(true)
    }
  }, [
    LoadingLayouts
  ]);
  if (!isReady) {
    return <div className="flex md:flex-row flex-wrap p-4 w-full" >
      <div className="w-full" >
        <div style={{ height: "50vh", }} className='flex items-center justify-center'>
          <div className="h-20  w-20 flex">
            <div className="spinner-border-white-full animate-spin w-14 h-14 border-4 border-white border-t-transparent rounded-full"></div>

          </div>
        </div>
      </div>
    </div>

  }
  return (
    <div className="w-full h-fit pb-16">
      <div className="gap-2 flex flex-col">
        <CopyNotification show={copied} />

        <p className="text-2xl mt-8" style={{ fontFamily: "brico" }}>
          {GLOBAL_LANGUAGE[language].steps4.title}
        </p>
        <p className="text-[#8A8A8E]">
          {GLOBAL_LANGUAGE[language].steps4.subtitle}
        </p>
      </div>

      <div className="md:space-y-0 space-y-4 mt-4">
        {isReadyToRender &&
          beneficiarios.map((beneficiario, index) => (
            <div key={index} className="md:mb-0 bg-[#1a1b22] md:bg-transparent rounded-lg md:rounded-none p-4 md:p-0">
              <Benefactor
                ErrorCompany={ErrorCompany}
                copyToClipboard={copyToClipboard}
                ListCountry={ListCountry}
                index={index}
                data={beneficiario}
                onChange={(field, value) =>
                  handleBeneficiarioChange(index, field, value)
                }
                error={errorMesagge}
              />
            </div>
          ))}
      </div>

      <div className="flex flex-col md:flex-row justify-between items-center gap-4 mt-6">
        <ButtonWhite
          label={GLOBAL_LANGUAGE[language].steps4.button_save}
          onClick={() => handleSave()}
          className="w-full md:w-auto order-2 md:order-1"
        />
        <ButtonTransparent
          label={GLOBAL_LANGUAGE[language].steps4.add}
          Icon={ADD}
          iconPosition="left"
          onClick={addBeneficiario}
          className="w-full md:w-auto order-1 md:order-2"
        />
      </div>

      <div className="w-full bg-[#5E5E63] h-[1px] my-6"></div>

      {errorMesagge && (
        <div className="w-full flex flex-col mb-4">
          <p className="text-[#FF928B] text-[16px]">{errorMesagge}</p>
        </div>
      )}

      <div className="flex flex-col-reverse md:flex-row justify-between w-full gap-4">
        <ButtonBack
          label={GLOBAL_LANGUAGE[language].steps4.button_back}
          Icon={BACK}
          onClick={onClickBack}
          loading={LoadingBack}
          className="w-full md:w-auto"
        />
        <ButtonNext
          isDisabled={buttonOff}
          label={GLOBAL_LANGUAGE[language].steps4.button_next}
          Icon={NEXT}
          loading={loading}
          onClick={() => onClick(beneficiarios)}
          className="w-full md:w-auto"
        />
      </div>
    </div>
  );
};

export default Step4;
